'use client';
import {PepIcon} from '#/features/components/PepIcon';
import {type PepIconName} from '@calvium/pep-icons';

type Props = {
  iconName: PepIconName;
  backgroundColor?: string;
  foregroundColor?: string;
  fringeColor?: string;
  size?: number;
  fringeWidth?: number;
  padding?: number;
};

/**
 * Svg component that assembles a map marker with a background, a foreground, a fringe and an icon.
 * Used to generate the encoded data string passed into the icon prop for the Marker component.
 */
export const MapMarkerSvg = (props: Props) => {
  const {
    backgroundColor = '#000000',
    foregroundColor = '#ffffff',
    fringeColor = '#666666',
    size = 32,
    fringeWidth = 8,
    iconName = 'LocationPin',
    padding = 8,
  } = props;

  const fringeSize = size + fringeWidth * 2;
  const containerSize = size;
  const iconSize = size - padding * 2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={fringeSize}
      height={fringeSize}
      viewBox={`0 0 ${fringeSize} ${fringeSize}`}
      stroke={foregroundColor}
    >
      <circle cx={fringeSize / 2} cy={fringeSize / 2} r={fringeSize / 2} fill={fringeColor} opacity={0.2} />
      <circle
        cx={fringeSize / 2}
        cy={fringeSize / 2}
        r={containerSize / 2}
        fill={backgroundColor}
        stroke={foregroundColor}
        strokeWidth={1}
      />
      <svg strokeWidth={1.5} width={iconSize} height={iconSize} x={padding * 2} y={padding * 2}>
        <PepIcon iconName={iconName} className="'w-2" />
      </svg>
    </svg>
  );
};
